<div class="flex flex-col">
  @for (collection of collections; track collection) {
    <div
      class="flex text-primary items-center">
      @if (collection.id === collectionId) {
        <span>
          Poslat zprávu všem
        </span>
      }
      @if (collection.id !== collectionId) {
        <pc-shared-nibble-type-icon [disabled]="collection.currentUserRelation !== 'owns'"
                                    type="COLL_CUSTOM"></pc-shared-nibble-type-icon>
        <pc-shared-collection-label (click)="openCollection.emit(collection.id)" [collection]="collection"
                                    class="cursor-pointer flex-auto overflow-hidden"></pc-shared-collection-label>
        <mat-icon (click)="sendMessageToCollection.emit(collection.id)"
                  [title]="'personal_content.coop.write_message' | transloco"
                  class="cursor-pointer">mail
        </mat-icon>
        <mat-icon (click)="openCollectionInTab.emit(collection.id)"
                  [title]="'personal_content.messages.open_in_new_window' | transloco"
                  class="cursor-pointer ml-2">open_in_new
        </mat-icon>
      }
    </div>
  }
</div>
